import i18n from "@/utils/i18n";

/** Backend type: 0=ON_SITE, 1=ONLINE, 2=UNIT, 3=NONUNIT */
const TYPE_TO_KEY: Record<number, string> = {
  0: "faceToFace",
  1: "online",
  2: "unit",
  3: "nonUnit",
};

const FORMAT_TO_KEY: Record<string, string> = {
  uniteli: "unit",
  canli: "online",
  yuzYuze: "faceToFace",
  online: "online",
  live: "online",
  hybrid: "unit",
  unit: "unit",
  UNIT: "unit",
  ON_SITE: "faceToFace",
  ONLINE: "online",
};

/**
 * Backend type numarası veya format string'inden teslimat tipi etiketini döner.
 */
export function getDeliveryTypeLabel(type?: number, format?: string): string {
  const fromTypeKey = type != null ? TYPE_TO_KEY[type] : undefined;
  const fromFormatKey = format ? FORMAT_TO_KEY[format] : undefined;
  const key = fromTypeKey ?? fromFormatKey;
  if (!key) return "-";
  return i18n.t(`requestAndApproval.educationTypes.${key}`);
}

/**
 * EDU-<base36 timestamp>-<4 random> biçiminde okunabilir eğitim kodu üretir.
 */
export function generateEducationCode(): string {
  const timestamp = Date.now().toString(36).toUpperCase();
  const random = Math.random().toString(36).substring(2, 6).toUpperCase();
  return `EDU-${timestamp}-${random}`;
}
